import { useMutation, useQuery } from '@tanstack/react-query'
import { apiFetch } from '../lib/api'

export function useWaitlistSignup() {
  return useMutation({
    mutationFn: (email: string) =>
      apiFetch<{ data: { ok: boolean } }>('/waitlist', {
        method: 'POST',
        body: JSON.stringify({ email }),
      }),
  })
}

export function useWaitlistCount() {
  return useQuery({
    queryKey: ['waitlist', 'count'],
    queryFn: () => apiFetch<{ data: { count: number } }>('/waitlist/count'),
    staleTime: 5 * 60 * 1000,
  })
}
